import { subscriptionSourceEnum, subscriptionStatusEnum } from "./subscription";
import { userStatusSchema } from "./user";
import { z } from "zod";

export const signupSourceEnum = z.enum(["web", "ios", "android"]);
export type SignupSourceEnum = z.infer<typeof signupSourceEnum>;

export const adminUserStatsSchema = z.object({
  userId: z.string(),
  userName: z.string(),
  userEmail: z.string(),
  userCreatedAt: z.date(),
  userLanguage: z.enum(["en", "fr", "de", "es", "it"]),
  isConfirmed: z.boolean(),
  signupSource: signupSourceEnum.nullable(),
  lastOnboardingStep: z.number().nullable(),
  status: userStatusSchema,
  hasActiveOrganization: z.boolean(),
  lastLoginAt: z.date().nullable(),
  authProviders: z.string().nullable(),
  subscriptionPlan: z.enum(["lite", "plus", "premium", "enterprise"]).nullable(),
  subscriptionStatus: subscriptionStatusEnum.nullable(),
  subscriptionSource: subscriptionSourceEnum.nullable(),
  organizationCountry: z.string().nullable(),
  organizationNames: z.array(z.string()),
  organizationIds: z.array(z.string()),
  invoiceCount: z.number(),
  estimateCount: z.number(),
  creditNoteCount: z.number(),
  billCount: z.number(),
  relationCount: z.number(),
  lastDocumentCreatedAt: z.date().nullable(),
});

export type AdminUserStatsSchema = z.infer<typeof adminUserStatsSchema>;
